import React, { useEffect, useState } from "react";
import "./courseboard.css";
import Switch from "react-switch";
import {
  ChevronLeft,
  ChevronRight,
  Pencil,
  SquareCheckBig,
} from "lucide-react";
import NewGroup from "../Groups/NewGroup";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Gameboard from "./Gameboard";
import apiServiceHandler from "../../service/apiService";
import GroupCard from "../Groups/Group/GroupCard";
import { Breathing } from "react-shimmer";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import GameboardNew from "./GameboardNew";

const CourseBoard = () => {
  const navigate = useNavigate();
  let location = useLocation().state;
  const [course, setCourse] = useState(location.course || {});
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const currentStep = course?.steps[currentStepIndex];
  const [isEditing, setIsEditing] = useState(false);
  const [associateGroups, setAssociateGroups] = useState([])
  const [newTitle, setNewTitle] = useState(course?.title);
  const [imageLoaded, setImageLoaded] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || null;

  const handleNextStep = () => {
    if (currentStepIndex < course.steps.length - 1) {
      setCurrentStepIndex(currentStepIndex + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async (id, newTitle) => {
    try {
      const updateTitle = await apiServiceHandler("PATCH", "api/courses", {
        id,
        title: newTitle,
      });
      if (updateTitle.auth) {
        setCourse(updateTitle.updatedData);
        setIsEditing(false);
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error("Something went wrong in updating course title");
    } finally {
      setIsEditing(false);
    }
  };

  const [progress, setProgress] = useState(0);
  const [steps, setSteps] = useState([])
  const [continueBtn, setContinueBtn] = useState(0);

  const width = 1100;
  const height = 28;
  const cornerRadius = 8;
  const filledWidth = `${progress}%`;


  const getUserCourseProgress = async () => {
    try {
      const response = await apiServiceHandler("GET", `api/courses/progress?courseCode=${course.course_code}`, {});
      setProgress(response?.courses_progress?.overall_progress)
      setSteps(response?.courses_progress?.steps)

      const stepsCal = response?.courses_progress?.steps;
      const count = stepsCal.length - 1

      if (stepsCal[count].step_progress > 0) {
        setContinueBtn(count);
      } else {
        for (let i = count - 1; i >= 0; i--) {
          if (stepsCal[i].step_progress == 100) {
            setContinueBtn(i + 1 >= 0 ? i + 1 : 0);
            break;
          } else {
            if (stepsCal[i].step_progress > 0) {
              setContinueBtn(i);
              break;
            }
          }
        }
      }
    } catch (error) {
      toastr.error(error.response?.data?.message);
      console.error("Something went wrong");
    }
  }

  const getAssociatedGroups = async () => {
    const courseId = location?.course?._id
    try {
      const response = await apiServiceHandler("GET", `api/courses/associate/${courseId}`, {});
      if (response.status) {
        setAssociateGroups(response.data)
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error("Something went wrong");
    }
  }

  useEffect(() => {
    getUserCourseProgress();
    getAssociatedGroups();
  }, [])

  return (
    <div className="board-page">
      <div className="page-back">
        <button className="back-button" onClick={() => navigate('/courses')}>
          <span className="icon">
            <ChevronLeft size={32} />
          </span>
          <span className="button-label">Back</span>
        </button>
      </div>
      {course ? (
        <div className="board-page-content">
          <div className="board-page-header">
            {/*  
          <div className="board-page-header-eyebrow">
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <div className="va-spacer">{checked ? "Coach View" : "Student View"}</div>
              <Switch
                checked={checked}
                onChange={handleChange}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={30}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={20}
                width={48}
                className="react-switch"
                id="material-switch"
              />
            </div>
          </div>
          */}
            <div className="board-page-header-top">
              <div className="board-page-header-content">
                <div className="board-page-header-heading">
                  <div className="default-slot">
                    <div className="default-slot-content">
                      {isEditing ? (
                        // Editable input field when in editing mode
                        <input
                          type="text"
                          value={newTitle}
                          onChange={(e) => setNewTitle(e.target.value)}
                          className="title-edit-input"
                        />
                      ) : (
                        // Display title when not editing
                        <span className="board-heading">{course.title}</span>
                      )}
                    </div>
                    {isEditing ? (
                      // Show checkmark when in editing mode
                      <SquareCheckBig
                        // fill="#d1b794"
                        color="#d1b794"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSaveClick(course._id, newTitle)}
                      />
                    ) : (
                      userDetails &&
                      userDetails.admin && (
                        <Pencil
                          fill="#d1b794"
                          color="#d1b794"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                          onClick={handleEditClick}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 
          <div className="current-step">
            <button
              className="step-btn"
              style={{ marginRight: "1rem" }}
              onClick={handlePrevStep}
            >
              <ChevronLeft />
            </button>
            <div className="current-step-panel">
              {!imageLoaded && (
                <div className="shimmer-effect">
                  <Breathing />
                </div>
              )}
              <img
                className="current-step-image"
                src={
                  currentStep.image ||
                  "https://firebasestorage.googleapis.com/v0/b/jurni-prod.appspot.com/o/images%2Fcard-image-placeholder.png?alt=media&token=1fc21a26-8b3e-49a8-aba2-1e6f6d05fc80"
                }
                alt={`Step ${currentStepIndex + 1}`}
                onLoad={() => setImageLoaded(true)}
                style={imageLoaded ? {} : { display: "none" }}
              />
              <div className="current-step-content">
                <p className="current-step-index">
                  Step {currentStepIndex + 1} out of {course.steps.length}
                </p>
                <div className="current-step-heading">
                  <div className="default-slot step-heading">
                    <div className="default-slot-content">
                      {currentStep.title}
                    </div>

                    <Pencil
                      fill="#d1b794"
                      color="#d1b794"
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                    />

                  </div>
                </div>
                <div className="current-step-desc">
                  <div className="default-slot step-desc">
                    <div className="default-slot-content">
                      {currentStep.description}
                    </div>

                    <Pencil
                      fill="#d1b794"
                      color="#d1b794"
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                    />

                  </div>
                </div>
                <button
                  className="step-continue-btn"
                  onClick={() =>
                    navigate(
                      `/courses/step/${currentStep.title
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`,
                      { state: { currentStep, id: course._id } }
                    )
                  }
                >
                  Continue
                </button>
              </div>
            </div>
            <button
              className="step-btn"
              style={{ marginLeft: "1rem" }}
              onClick={handleNextStep}
            >
              <ChevronRight />
            </button>
          </div>
          */}
          <div className="course-desc">
            {/*
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <h2 className="course-desc-heading">Your Course</h2>
              <Pencil
                fill="#d1b794"
                color="#d1b794"
                style={{ width: "15px", height: "15px", cursor: "pointer" }}
              />
            </div>
            */}
            <div className="course-desc-panel">
              <div className="course-desc-panel-content">
                <div className="default-slot">
                  <div className="default-slot-content">
                    <p>{course.description}</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="progress-div">Progress</div>
              <div className="course-desc-panel-progress">
                <div className="vrp-wrapper">
                  <div className="vrp-inner" style={progress > 55 ? { color: '#26262f' } : { color: '#fff' }}>{progress}%</div>
                  <svg
                    width="90%"
                    height={height + 40}
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="10"
                      y="20"
                      width="100%"
                      height={height}
                      rx={cornerRadius}
                      ry={cornerRadius}
                      fill="#26262f"
                    />
                    <rect
                      x="10"
                      y="20"
                      width={filledWidth}
                      height={height}
                      rx={cornerRadius}
                      ry={cornerRadius}
                      fill="#d1b794"
                      style={{
                        transition: "width 1000ms linear"
                      }}
                    />
                  </svg>
                </div>
              </div>
              {progress > 0 && <div className="continue-btn">
                <button className="cont-btn"
                  style={{
                    transform: `translateX(calc(${progress == 0 ? 10 : progress * 10}px))`,
                    transition: 'transform 1000ms linear',
                    marginTop: '10px'
                  }}
                  onClick={() =>
                    navigate(
                      `/courses/step/${course.steps[continueBtn].title
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`,
                      { state: { currentStep: course.steps[continueBtn], id: course._id, continueBtn, courseCode: course.course_code } }
                    )
                  }>Continue</button>
              </div>}
            </div>
          </div>
          {course.course_code === "boa" || course.course_code === "club84" ? <GameboardNew course={course} steps={steps} /> : <Gameboard course={course} steps={steps} />}
          <div className="associated-groups-container">
            <h2>Associated Group </h2>
            <div className="group-page-section__body">
              <div className="card-grid-container">
                {associateGroups && associateGroups?.length > 0 && associateGroups?.map((group) => (
                  <GroupCard group={group} />
                ))}

              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Loading course...</p>
      )}
    </div>
  );
};

export default CourseBoard;
